import { application } from "./controllers/application"
import ProAddressAutocompleteController from "@pro/controllers/pro_address_autocomplete_controller"
import ProSentController from "@pro/controllers/pro_sent_controller"
import ProSidebarController from "@pro/controllers/pro_sidebar_controller"
import ProTelephonyProvisionController from "@pro/controllers/pro_telephony_provision_controller"
import ProTelephonyPanelController from "@pro/controllers/pro_telephony_panel_controller"
import ProTelephonyNumbersController from "@pro/controllers/pro_telephony_numbers_controller"
import ProVoicePickerController from "@pro/controllers/pro_voice_picker_controller"
import InquiryComposeController from "@pro/controllers/inquiry_compose_controller"
import InquiryThreadController from "@pro/controllers/inquiry_thread_controller"
import PropertyPurposeController from "@pro/controllers/property_purpose_controller"
import PropertyTypeFieldsController from "@pro/controllers/property_type_fields_controller"
import ListingKindController from "@pro/controllers/listing_kind_controller"
import ListingPublishChecklistController from "@pro/controllers/listing_publish_checklist_controller"
import ListingPhotosController from "@pro/controllers/listing_photos_controller"
import ProBrowserCallController from "@pro/controllers/pro_browser_call_controller"
import ListingImportController from "@pro/controllers/listing_import_controller"
import ListingRichTextController from "@pro/controllers/listing_rich_text_controller"
import ViewingSlotsController from "@pro/controllers/viewing_slots_controller"
import ViewingCalendarController from "@pro/controllers/viewing_calendar_controller"
import InboxKanbanController from "@pro/controllers/inbox_kanban_controller"
import InboxFiltersController from "@pro/controllers/inbox_filters_controller"
import ClipboardController from "@pro/controllers/clipboard_controller"
import QualificationQuestionsController from "@pro/controllers/qualification_questions_controller"
import InboxFunnelSettingsController from "@pro/controllers/inbox_funnel_settings_controller"
import ViewingPrefillController from "@pro/controllers/viewing_prefill_controller"
import InboxViewingPanelController from "@pro/controllers/inbox_viewing_panel_controller"
import ProDialogController from "@pro/controllers/pro_dialog_controller"
import LandlordsIndexController from "@pro/controllers/landlords_index_controller"
import TenantsIndexController from "@pro/controllers/tenants_index_controller"
import LandlordPickerController from "@pro/controllers/landlord_picker_controller"
import ContractRichTextController from "@pro/controllers/contract_rich_text_controller"
import ContractEditorController from "@pro/controllers/contract_editor_controller"
import ViewingInquiryPickerController from "@pro/controllers/viewing_inquiry_picker_controller"
import RentalListingPickerController from "@pro/controllers/rental_listing_picker_controller"
import DealsIndexController from "@pro/controllers/deals_index_controller"
import StartOnboardingFormController from "@pro/controllers/start_onboarding_form_controller"
import ProConnectionsController from "@pro/controllers/pro_connections_controller"
import ProWhatsappSignupController from "@pro/controllers/pro_whatsapp_signup_controller"
import AdCampaignBuilderController from "@pro/controllers/ad_campaign_builder_controller"
import MetaLeadFormPickerController from "@pro/controllers/meta_lead_form_picker_controller"
import ListingTabsController from "@pro/controllers/listing_tabs_controller"
import ProWalkthroughController from "@pro/controllers/pro_walkthrough_controller"
import WalkthroughStatusController from "@pro/controllers/walkthrough_status_controller"
import WalkthroughAudioFormController from "@pro/controllers/walkthrough_audio_form_controller"
import VideoWalkthroughController from "./controllers/video_walkthrough_controller"
import CookieConsentController from "./controllers/cookie_consent_controller"

application.register("pro-address-autocomplete", ProAddressAutocompleteController)
application.register("pro-sent", ProSentController)
application.register("pro-sidebar", ProSidebarController)
application.register("pro-telephony-provision", ProTelephonyProvisionController)
application.register("pro-telephony-panel", ProTelephonyPanelController)
application.register("pro-telephony-numbers", ProTelephonyNumbersController)
application.register("pro-voice-picker", ProVoicePickerController)
application.register("inquiry-compose", InquiryComposeController)
application.register("inquiry-thread", InquiryThreadController)
application.register("property-purpose", PropertyPurposeController)
application.register("property-type-fields", PropertyTypeFieldsController)
application.register("listing-kind", ListingKindController)
application.register("listing-publish-checklist", ListingPublishChecklistController)
application.register("listing-photos", ListingPhotosController)
application.register("pro-browser-call", ProBrowserCallController)
application.register("listing-import", ListingImportController)
application.register("listing-rich-text", ListingRichTextController)
application.register("viewing-slots", ViewingSlotsController)
application.register("viewing-calendar", ViewingCalendarController)
application.register("inbox-kanban", InboxKanbanController)
application.register("inbox-filters", InboxFiltersController)
application.register("clipboard", ClipboardController)
application.register("qualification-questions", QualificationQuestionsController)
application.register("inbox-funnel-settings", InboxFunnelSettingsController)
application.register("viewing-prefill", ViewingPrefillController)
application.register("inbox-viewing-panel", InboxViewingPanelController)
application.register("pro-dialog", ProDialogController)
application.register("landlords-index", LandlordsIndexController)
application.register("tenants-index", TenantsIndexController)
application.register("landlord-picker", LandlordPickerController)
application.register("contract-rich-text", ContractRichTextController)
application.register("contract-editor", ContractEditorController)
application.register("viewing-inquiry-picker", ViewingInquiryPickerController)
application.register("rental-listing-picker", RentalListingPickerController)
application.register("deals-index", DealsIndexController)
application.register("start-onboarding-form", StartOnboardingFormController)
application.register("pro-connections", ProConnectionsController)
application.register("pro-whatsapp-signup", ProWhatsappSignupController)
application.register("ad-campaign-builder", AdCampaignBuilderController)
application.register("meta-lead-form-picker", MetaLeadFormPickerController)
application.register("listing-tabs", ListingTabsController)
application.register("pro-walkthrough", ProWalkthroughController)
application.register("walkthrough-status", WalkthroughStatusController)
application.register("walkthrough-audio-form", WalkthroughAudioFormController)
application.register("video-walkthrough", VideoWalkthroughController)
application.register("cookie-consent", CookieConsentController)
